module.exports = __webpack_public_path__ + "img/cs-jiaoyu_small.e826e267.jpg";